/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */
/* eslint max-len: 0 */
import { installIacoBase, installIacoJoystick } from './iacoComm';

// ------------------------- Piezo buzzer (NewTone) ---------------------------

const IACO_BUZZER_INCLUDE_KEY = 'IACO_piezo_buzzer';
const IACO_BUZZER_INCLUDE = '\n#include <NewTone.h>\n';

// A diferencia de otras familias, IACO no aplica el quirk octave === 3 ? 4:
// basePitch * octave llano, como el legacy.
export const IACO_piezo_buzzer = (block, generator) => {
  generator.definitions_[IACO_BUZZER_INCLUDE_KEY] = IACO_BUZZER_INCLUDE;
  const value = block.getFieldValue('PIANO');
  const pitch = (value.basePitch * value.octave) || 131;
  const duration = value.duration || 1000;
  return `\nNewTone(12, ${pitch}, ${duration});\n`;
};

export const IACO_piezo_buzzer_variable = (block, generator) => {
  const duration = generator.valueToCode(block, 'DURATION', generator.ORDER_NONE);
  const tone = generator.valueToCode(block, 'VAR', generator.ORDER_NONE);
  generator.definitions_[IACO_BUZZER_INCLUDE_KEY] = IACO_BUZZER_INCLUDE;
  return `\nNewTone(12, ${tone}, ${duration});\n`;
};

export const IACO_piezo_buzzerno = (block, generator) => {
  generator.definitions_[IACO_BUZZER_INCLUDE_KEY] = IACO_BUZZER_INCLUDE;
  return 'noNewTone(12);';
};

// ------------------------- Comunicacion ------------------------------------

export const IACO_buttons = (block, generator) => {
  const code_btn1 = generator.statementToCode(block, 'BUTN1').replace(/&quot;/g, '"');
  const code_btn2 = generator.statementToCode(block, 'BUTN2').replace(/&quot;/g, '"');
  const code_btn3 = generator.statementToCode(block, 'BUTN3').replace(/&quot;/g, '"');
  const code_btn4 = generator.statementToCode(block, 'BUTN4').replace(/&quot;/g, '"');
  const code_btna = generator.statementToCode(block, 'BUTNA').replace(/&quot;/g, '"');
  const code_btnb = generator.statementToCode(block, 'BUTNB').replace(/&quot;/g, '"');

  installIacoJoystick(generator, ` else if (inicioMensaje.equals("OMNP")) {
    for (int i = 0; i < mensaje.length(); i++) {
      if (mensaje.charAt(i) == ',') {
        IACOangulo = mensaje.substring(i + 1).toInt();
      }
    }
    ${code_btn1}
  } else if (inicioMensaje.equals("JOYS")) {
    ${code_btn2}
  } else if (inicioMensaje.equals("JOYH")) {
    int IACOrotar = mensaje.substring(4).toInt();
    if (IACOrotar < 0) {
      ${code_btn3}
    } else if (IACOrotar > 0) {
      ${code_btn4}
    }
  } else if(inicioMensaje.equals("JOYA")) {
    ${code_btna}
  } else if(inicioMensaje.equals("JOYB")) {
    ${code_btnb}
  }`);

  return `
  if (BT1.available()) {
    command = BT1.read();
    bufferBT += command;
    if (command == '\\n') {
      analizarMensaje(bufferBT);
      bufferBT = "";
    }
  }
`;
};

// Registra los defines base para compilar aunque no haya IACO_buttons en el workspace.
export const IACO_angle = (block, generator) => {
  installIacoBase(generator);
  return ['IACOangulo', generator.ORDER_ATOMIC];
};

// ------------------------- Motor omnidireccional --------------------------

const MOTORS_INCLUDE_KEY = 'motors';
const MOTORS_INCLUDE = `
#include <Arduino.h>
#include <SoftPWM.h>
`;

const IACO_MOTOR_HELPER_KEY = 'IACO_motor';
const IACO_MOTOR_HELPER = `
// MI sup. MD sup. MD inf. MI inf
#define MOTOR_PINS (uint8_t[8]) {10, 11, 2, 3, 4, 5, 7, 6}

/** Set the positive and negative directions for the motors */
#define MOTOR_DIRECTIONS (uint8_t[4]) {1, 1, 0, 0}

#define MOTOR_POWER_MIN 28  // 28/255
int8_t velocidad = 100;

void carBegin() {
  for (uint8_t i = 0; i < 8; i++) {
    SoftPWMSet(MOTOR_PINS[i], 0);
    SoftPWMSetFadeTime(MOTOR_PINS[i], 100, 100);
  }
}

void carSetMotors(int8_t power0, int8_t power1, int8_t power2, int8_t power3) {
  bool dir[4];
  int8_t power[4] = { power0, power1, power2, power3 };
  int8_t newPower[4];

  for (uint8_t i = 0; i < 4; i++) {
    dir[i] = power[i] > 0;

    if (MOTOR_DIRECTIONS[i]) dir[i] = !dir[i];

    if (power[i] == 0) {
      newPower[i] = 0;
    } else {
      newPower[i] = map(abs(power[i]), 0, 100, MOTOR_POWER_MIN, 255);
    }
    SoftPWMSet(MOTOR_PINS[i * 2], dir[i] * newPower[i]);
    SoftPWMSet(MOTOR_PINS[i * 2 + 1], !dir[i] * newPower[i]);
  }
}

void carMove(int16_t angle, int8_t power) {
  int8_t power_0, power_1, power_2, power_3;
  // Make forward 0
  angle += 90;
  // Offset angle as 0 to the front
  float rad = angle * PI / 180;

  power /= sqrt(2);


  power_0 = (power * sin(rad) - power * cos(rad));
  power_1 = (power * sin(rad) + power * cos(rad));
  power_2 = (power * sin(rad) - power * cos(rad));
  power_3 = (power * sin(rad) + power * cos(rad));

  carSetMotors(power_0, power_1, power_2, power_3);
}

void carRotate(int16_t angle, int8_t power, int8_t rot) {
  int8_t power_0, power_1, power_2, power_3;
  float speed;
  // Make forward 0
  angle += 90;
  // Offset angle as 0 to the front
  float rad = angle * PI / 180;

  if (rot == 0) speed = 1;  // limit power value over 100
  else speed = 0.5;

  power /= sqrt(2);  // limit power value over 100

  power_0 = (power * sin(rad) - power * cos(rad)) * speed - rot * speed;
  power_1 = (power * sin(rad) + power * cos(rad)) * speed + rot * speed;
  power_2 = (power * sin(rad) - power * cos(rad)) * speed + rot * speed;
  power_3 = (power * sin(rad) + power * cos(rad)) * speed - rot * speed;

  carSetMotors(power_0, power_1, power_2, power_3);
}

void carDrift(int16_t angle, int8_t power, int8_t rot, bool drift) {
  int8_t power_0, power_1, power_2, power_3;
  float speed;
  // Make forward 0
  angle += 90;
  // Offset angle as 0 to the front
  float rad = angle * PI / 180;

  if (rot == 0) speed = 1;
  else speed = 0.5;

  power /= sqrt(2);
  // Calculate 4 wheel
  if (drift) {
    power_0 = (power * sin(rad) - power * cos(rad)) * speed;
    power_1 = (power * sin(rad) + power * cos(rad)) * speed;
    power_2 = (power * sin(rad) - power * cos(rad)) * speed + rot * speed * 2;
    power_3 = (power * sin(rad) + power * cos(rad)) * speed - rot * speed * 2;
  } else {
    power_0 = (power * sin(rad) - power * cos(rad)) * speed - rot * speed;
    power_1 = (power * sin(rad) + power * cos(rad)) * speed + rot * speed;
    power_2 = (power * sin(rad) - power * cos(rad)) * speed + rot * speed;
    power_3 = (power * sin(rad) + power * cos(rad)) * speed - rot * speed;
  }

  carSetMotors(power_0, power_1, power_2, power_3);
}

void carStop() {
  carSetMotors(0, 0, 0, 0);
}
`;

const IACO_MOTOR_SETUP_KEY = 'motors';
const IACO_MOTOR_SETUP = `
  SoftPWMBegin();
  carBegin();
`;

const installIacoMotor = (generator) => {
  generator.definitions_[MOTORS_INCLUDE_KEY] = MOTORS_INCLUDE;
  generator.definitions_[IACO_MOTOR_HELPER_KEY] = IACO_MOTOR_HELPER;
  generator.setups_[IACO_MOTOR_SETUP_KEY] = IACO_MOTOR_SETUP;
};

export const IACO_motor = (block, generator) => {
  installIacoMotor(generator);
  switch (block.getFieldValue('DIR')) {
    case '3': return 'carMove(0, velocidad);\n';
    case '4': return 'carMove(180, velocidad);\n';
    case '5': return 'carMove(90, velocidad);\n';
    case '6': return 'carRotate(0, 0, 90);\n';
    case '7': return 'carMove(270, velocidad);\n';
    case '8': return 'carRotate(0, 0, 180);\n';
    case '9': return 'carStop();\n';
    default: return '';
  }
};

export const IACO_motor_degrees = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  installIacoMotor(generator);
  return `\n  carMove(${angle}, velocidad);\n`;
};
